import { ApartmentDTO } from '../model/ApartmentDTO';
import { InstanceType } from '../enums/InstanceType';
import { LocationDTO } from '../model/LocationDTO';
import { BoIdMapping } from '../types/BoIdMapping';

export function getBoIdMapping(instanceType: InstanceType, bdo: any): BoIdMapping {
	switch(instanceType) {
		case InstanceType.Apartment:
			const apartment = bdo as ApartmentDTO;

			return {
				[InstanceType.Apartment]: apartment.catalogNumber,
				[InstanceType.Floor]: `${apartment.housingBlock.id}_${apartment.floor.id}`,
				[InstanceType.HousingBlock]: apartment.housingBlock.id.toString(),
				...getBoIdMapping(InstanceType.ApartmentLocation, apartment.location)
			};
		case InstanceType.ApartmentLocation:
			const location = bdo as LocationDTO;
			var catalogNo = location.catalogNumber;
			if (location.catalogMarketingNumber && location.catalogMarketingNumber != "") {
				catalogNo = location.catalogMarketingNumber;
			}

			return {
				[InstanceType.ApartmentLocation]:					
					location.distinguishPremiumVariant
						? `${catalogNo}-${location.isPremium ? 1 : 0}`
						: catalogNo
			};
		default:
			throw new Error("Not implemented");
	}
}
